import React, { useEffect, useState } from "react";
import { db } from "./firebase"; // ملف firebase.js اللي عرفنا فيه config
import { collection, getDocs } from "firebase/firestore";

const ConsultationsList = () => {
  const [consultations, setConsultations] = useState([]);

  // تحميل البيانات من فايربيز
  useEffect(() => {
    const fetchConsultations = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "consultations"));
        const data = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setConsultations(data);
      } catch (error) {
        console.error("Error fetching consultations:", error);
      }
    };

    fetchConsultations();
  }, []);

  return (
    <div className="consultations">
      <div className="container">
        <h2>📋 قائمة الاستشارات</h2>
        {consultations.length === 0 ? (
          <p>لا يوجد استشارات مسجلة حالياً.</p>
        ) : (
          <table className="consultationsTable">
            <thead>
              <tr>
                <th>الاسم بالكامل</th>
                <th>رقم التليفون</th>
                <th>تفاصيل الاستشارة</th>
                <th>تاريخ الإضافة</th>
              </tr>
            </thead>
            <tbody>
              {consultations.map((c) => (
                <tr key={c.id}>
                  <td>{c.name}</td>
                  <td>{c.phone}</td>
                  <td>{c.details}</td>
                  <td>
                    {c.createdAt
                      ? new Date(c.createdAt.seconds * 1000).toLocaleString()
                      : "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* شوية CSS بسيط */}
      <style>{`
        .consultations {
          margin: 40px auto;
        }
        .consultations h2 {
          margin-bottom: 20px;
          text-align: center;
        }
        .consultationsTable {
          width: 100%;
          border-collapse: collapse;
          background: #fff;
          box-shadow: 0 0 10px rgba(0,0,0,0.1);
        }
        .consultationsTable th, .consultationsTable td {
          padding: 12px;
          border: 1px solid #ddd;
          text-align: center;
        }
        .consultationsTable th {
          background: #007bff;
          color: #fff;
        }
        .consultationsTable tr:nth-child(even) {
          background: #f9f9f9;
        }
      `}</style>
    </div>
  );
};

export default ConsultationsList;
